import actionTypes from './actionTypes';
// import type { ShippingOptions } from '../../types/ShippingOptions.type';

type ShippingOptionsSetStartAction = {
  type: string;
  shippingMethodId: string;
};

type ShippingOptionsSetFailAction = {
  type: string;
  error: any;
};

type ShippingOptionsAction = {
  type: string;
};

const SHIPPING_OPTIONS_SET_START = (
  shippingMethodId: string
): ShippingOptionsSetStartAction => ({
  type: actionTypes.SHIPPING_OPTIONS_SET_START,
  shippingMethodId,
});

const SHIPPING_OPTIONS_SET_FAIL = (
  error: any
): ShippingOptionsSetFailAction => ({
  type: actionTypes.SHIPPING_OPTIONS_SET_FAIL,
  error,
});

const SHIPPING_OPTIONS_SET_SUCCESS = (): ShippingOptionsAction => ({
  type: actionTypes.SHIPPING_OPTIONS_SET_SUCCESS,
});

const SHIPPING_OPTIONS_REFRESH_START = (): ShippingOptionsAction => ({
  type: actionTypes.SHIPPING_OPTIONS_REFRESH_START,
});

const SHIPPING_OPTIONS_REFRESH_SUCCESS = (): ShippingOptionsAction => ({
  type: actionTypes.SHIPPING_OPTIONS_REFRESH_SUCCESS,
});

const SHIPPING_OPTIONS_REFRESH_FAIL = (): ShippingOptionsAction => ({
  type: actionTypes.SHIPPING_OPTIONS_REFRESH_FAIL,
});

export default {
  SHIPPING_OPTIONS_SET_START,
  SHIPPING_OPTIONS_SET_FAIL,
  SHIPPING_OPTIONS_SET_SUCCESS,
  SHIPPING_OPTIONS_REFRESH_START,
  SHIPPING_OPTIONS_REFRESH_SUCCESS,
  SHIPPING_OPTIONS_REFRESH_FAIL,
};
